<template>
    <v-card style="border-radius: 1em;" class="pa-2">
        <v-card-text class="text-xs-center">
          <v-layout row>
            <v-flex xs1>
              <v-tooltip bottom>
              <v-btn slot="activator" icon @click="voltar">
                <v-icon color="primary">west</v-icon>
              </v-btn>
              <span>Voltar</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs10>
              <h1 class="mb-2 primary--text">Cupom Apetrus</h1>
            </v-flex>
          </v-layout>
          <v-stepper v-model="step" style="box-shadow: none;">
            <v-stepper-items>
              <v-stepper-content step='1' class="pa-0">
                <v-layout row wrap justify-end>
                  <v-btn small icon color="primary" @click="step++">
                    <v-icon>add</v-icon>
                  </v-btn>
               </v-layout>
                <v-flex xs12 class="mt-3">
                  <v-list dense two-line>
                    <v-list-tile v-if="codigosPromocionais.length === 0">
                      <v-list-tile-content>
                        <v-list-tile-title class="font-weight-light body-2 text-xs-center">Não possui código promocional cadastrado</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(codigo, index) in codigosPromocionais">
                      <v-divider :key="-index" v-if="index > 0" inset></v-divider>
                      <v-list-tile :key="codigo.id"  :style="{'color': codigo.litros_restantes && codigo.litros_restantes < 1 || (codigo.data_fim != null && new Date(`${codigo.data_fim}T23:59:59`) < new Date()) ? 'red' : 'gray'}">
                        <v-list-tile-avatar>
                          <svg-filler
                            :path="require(`@/assets/combs/gas.svg`)"
                            width="50px"
                            height="50px"
                          />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-if="codigo.desconto"
                            class="font-weight-light body-2"
                          >{{codigo.desconto}}% de desconto</v-list-tile-title>
                          <v-list-tile-title
                            v-else-if="codigo.desconto_reais"
                            class="font-weight-light body-2"
                          >{{ codigo.desconto_reais | currency({fractionCount: 2}) }} de desconto</v-list-tile-title>
                          <v-list-tile-sub-title
                          :style="{'color': codigo.litros_restantes && codigo.litros_restantes < 1 ||
                          (codigo.data_fim != null && new Date(`${codigo.data_fim}T23:59:59`) < new Date()) ? 'red' : 'gray'}">
                          {{codigo.codigo}}
                          <span v-if="codigo.litros_restantes && codigo.litros_restantes < 1">(Volume esgotago)</span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                          <v-list-tile-sub-title
                            class="font-weight-light caption text--darken-2 text-xs-right"
                            :style="{'color': codigo.litros_restantes && codigo.litros_restantes < 1 || (codigo.data_fim != null && new Date(`${codigo.data_fim}T23:59:59`) < new Date()) ? 'red' : 'gray'}"
                          >{{new Date(`${codigo.data_inicio}T00:00:00`) >= new Date()? 'Válido a partir de':'Ficou válido a partir de'}} {{codigo.data_inicio | formatDate('DD/MM/YYYY')}}</v-list-tile-sub-title>
                          <v-list-tile-sub-title
                            v-if="codigo.tem_data_fim"
                            class="font-weight-light caption text--darken-2 text-xs-right"
                            :style="{'color': codigo.litros_restantes < 1 || (codigo.data_fim != null && new Date(`${codigo.data_fim}T23:59:59`) < new Date()) ? 'red' : 'gray'}"
                          >
                          <span v-if="codigo.data_fim != null && new Date(`${codigo.data_fim}T23:59:59`) < new Date()">
                            Data expirada
                          </span>
                          <span v-else>Até {{codigo.data_fim | formatDate('DD/MM/YYYY')}}</span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-menu
                            offset-x
                            max-width="230"
                            min-width="230"
                            right
                            transition="slide-x-transition"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on">
                                <v-icon color="grey darken-2">more_vert</v-icon>
                              </v-btn>
                            </template>
                            <v-list class="pa-0">
                              <v-list-tile ripple @click="carregarBanner(codigo)">
                                <v-list-tile-content>
                                  <v-list-tile-title
                                    class="font-weight-light body-1 success--text text-xs-center"
                                  >CARREGAR BANNER</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon color="success">image</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile ripple @click="visualizarDetalhes(codigo)">
                                <v-list-tile-content>
                                  <v-list-tile-title
                                    class="font-weight-light body-1 primary--text text-xs-center"
                                  >DETALHES</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon color="primary">visibility</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile ripple @click="vicularPosto(codigo)">
                                <v-list-tile-content>
                                  <v-list-tile-title
                                    class="font-weight-light body-1 secondary--text text-xs-center"
                                  >VINCULAR A POSTO</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon color="secondary">local_gas_station</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile ripple @click="vicularRede(codigo)">
                                <v-list-tile-content>
                                  <v-list-tile-title
                                    class="font-weight-light body-1 gray--text text-xs-center"
                                  >VINCULAR A REDE</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon color="gray">ac_unit</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-list-tile ripple @click="cancelarCodigo(codigo)">
                                <v-list-tile-content>
                                  <v-list-tile-title
                                    class="font-weight-light body-1 error--text text-xs-center"
                                  >APAGAR CÓDIGO</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon color="error">delete</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-stepper-content>
              <v-stepper-content step='2' class="pa-0">
                <v-layout row wrap justify-start>
                    <v-flex xs12 class="pb-0">
                      <v-text-field
                        v-model="codigo_model.codigo"
                        outline
                        label="Código da promoção"
                        counter="20"
                        mask="NNNNNNNNNNNNNNNNNNNN"
                        required
                        :rules="[
                              v => !!v || 'O campo é obrigatório'
                            ]"
                      ></v-text-field>
                    </v-flex>
                  <v-flex xs6 class="pb-0">
                    <v-text-field
                      v-model.lazy="codigo_model.desconto"
                      outline
                      label="Percentual do desconto"
                      suffix="%"
                      type="number"
                      required
                      :rules="[
                        () => parseFloat(codigo_model.desconto) >= 0 || 'Desconto inválido',
                        () => parseFloat(codigo_model.desconto) <= 100 || 'O desconto deve ser menor que 100%'
                      ]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="pb-0">
                    <v-menu
                      transition="scale-transition"
                      offset-y
                      full-width
                      lazy
                      max-width="290px"
                      min-width="290px"
                      :close-on-content-click="false"
                      v-model="menuDataInicial"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="codigo_model.data_inicio"
                          outline
                          v-on="on"
                          label="Data inicial"
                          required
                          :rules="[
                                v => !!v || 'O campo é obrigatório'
                              ]"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date_inicio"
                        no-title
                        locale="pt-br"
                        :allowed-dates="(date) => {
                          return Date.parse(date) >= today
                        }"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          flat
                          color="green darken-1"
                          class="caption font-weight-medium"
                          @click="menuDataInicial = false"
                        >FECHAR</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6 class="pb-0 pt-0">
                    <v-checkbox
                      v-model="codigo_model.tem_data_fim"
                      color="primary"
                      class="mt-0"
                      :hide-details="codigo_model.tem_data_fim"
                    >
                      <template slot="label">
                        <span class="body-2 grey--text">Possui data de expiração?</span>
                      </template>
                    </v-checkbox>
                    <v-menu
                      transition="scale-transition"
                      offset-y
                      full-width
                      lazy
                      max-width="290px"
                      min-width="290px"
                      :close-on-content-click="false"
                      v-model="menuDataFinal"
                    >
                      <template v-slot:activator="{ on }">
                        <v-slide-x-transition>
                          <v-text-field
                            v-model="codigo_model.data_fim"
                            outline
                            hide-details
                            v-on="on"
                            v-show="codigo_model.tem_data_fim"
                            class="pt-2"
                            readonly
                            label="Data de Expiração"
                          ></v-text-field>
                        </v-slide-x-transition>
                      </template>
                      <v-date-picker
                        v-model="date_fim"
                        no-title
                        locale="pt-br"
                        :allowed-dates="(date) => {
                          return Date.parse(date) >= today
                        }"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          flat
                          color="green darken-1"
                          class="caption font-weight-medium"
                          @click="menuDataFinal = false"
                        >FECHAR</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                  <v-checkbox
                    v-model="codigo_model.possui_valor_limite"
                    color="primary"
                    class="mt-0"
                    :hide-details="codigo_model.possui_valor_limite"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Limitar valor de uso</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      outline
                      v-if="codigo_model.possui_valor_limite"
                      v-money="money"
                      v-model.lazy="codigo_model.valor_limite"
                      class="pt-2"
                      label="Valor limite"
                      :rules="[
                        () => valor_limite_teste > 0 || 'Valor inválido'
                      ]"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                    v-model="possui_limete_por_cliente"
                    color="primary"
                    class="mt-0"
                    :hide-details="possui_limete_por_cliente"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Limitar valor de uso por cliente</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      outline
                      v-if="possui_limete_por_cliente"
                      v-money="money"
                      v-model.lazy="codigo_model.limite_por_cliente"
                      class="pt-2"
                      label="Valor limite por cliente"
                      :rules="[
                        () => limite_por_cliente_teste > 0 || 'Valor inválido'
                      ]"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                    v-model="possuiLink"
                    color="primary"
                    class="mt-0"
                    :hide-details="possuiLink"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Possui link para site?</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      v-show="possuiLink"
                      v-model="codigo_model.link_site"
                      type="text"
                      outline
                      placeholder="https://www.dominio.com.br/"
                      class="pt-2"
                      label="Digite o link do site"
                      :rules="[
                        () => url_teste == true || 'Link inválido'
                      ]"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                    v-model="codigo_model.qtd_codigos_limitado"
                    color="primary"
                    class="mt-0"
                    :hide-details="codigo_model.qtd_codigos_limitado"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Limitar quantidade de códigos</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      outline
                      v-model="codigo_model.qtd_codigos"
                      v-show="codigo_model.qtd_codigos_limitado"
                      hide-details
                      class="pt-2"
                      type="number"
                      label="Códigos disponíveis"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox
                    v-model="codigo_model.usos_limitados"
                    color="primary"
                    class="mt-0"
                    :hide-details="codigo_model.usos_limitados"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Limitar usos para cada usuário</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      v-show="codigo_model.usos_limitados"
                      v-model="codigo_model.qtd_usos_usuario"
                      type="number"
                      outline
                      hide-details
                      class="pt-2"
                      label="Usos por usuário"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
                <v-flex xs8>
                  <v-checkbox
                    v-model="possui_limete_combustivel"
                    color="primary"
                    class="mt-0"
                    :hide-details="possui_limete_combustivel"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Vincular combustível</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-select
                      single-line
                      v-show="possui_limete_combustivel"
                      :items="combustiveis" item-text="nome"
                      item-value="id_combustivel"
                      v-model="codigo_model.combustivel"
                      outline
                      placeholder="Selecione um combustível"
                    />
                  </v-slide-x-transition>
                </v-flex>
                <v-flex xs12 class="pb-0 pt-0">
                  <v-checkbox
                    color="primary"
                    class="mt-0"
                    :hide-details="codigo_model.possui_mensagem"
                    v-model="codigo_model.possui_mensagem"
                  >
                    <template slot="label">
                      <span class="body-2 grey--text">Deseja adicionar uma mensagem à promoção?</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      v-show="codigo_model.possui_mensagem"
                      v-model="codigo_model.mensagem_cupom"
                      outline
                      class="pt-2"
                      label="Mensagem"
                      counter="30"
                      :required="codigo_model.possui_mensagem"
                      :rules="codigo_model.possui_mensagem ? [
                            v => !!v || 'Insira uma mensagem válida',
                            v => v && v.length < 31 || 'A mensagem só pode ter 31 dígitos no máximo'
                          ] : []"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
                </v-layout>
                <v-btn block color="primary" @click="inserirCodigo">Cadastrar</v-btn>
              </v-stepper-content>
              <v-stepper-content step='3' class="pa-0">
                <v-layout row wrap justify-space-between class="pa-2">
                    <v-flex xs12>
                        <h3 class="text-xs-center">Insira os postos que você deseja vincular ao Cupom Apetrus</h3>
                        <v-tooltip bottom>
                          <v-btn slot="activator" class="mt-3" round small @click="inserirTodosPosto">Inserir todos</v-btn>
                          Inserir todos os postos
                        </v-tooltip>
                        <v-layout justify-center class="mt-3">
                          <v-flex xs8>
                            <v-text-field
                              v-model="filtroPosto.nome_fantasia__icontains"
                              label="Digite o nome do posto"
                              box
                              dense
                              prepend-inner-icon="search"
                            />
                          </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6>
                        <h4 class="text-xs-center">Lista de postos</h4>
                        <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em; max-height: 30em; overflow:scroll; overflow-x:hidden;"  class="mr-1">
                            <v-list-tile v-for="(posto, index) in postosSemVinculo" :key="index" ripple @click="inserirEmLista(posto, index)">
                                <v-list-tile-avatar>
                                    <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                    <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="postosSemVinculo.length === 0">
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs6>
                        <h4 class="text-xs-center">Postos vinculados</h4>
                        <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em; max-height: 30em; overflow:scroll; overflow-x:hidden;" class="ml-1">
                            <v-list-tile v-for="(posto, index) in postosVinculados" :key="index" ripple @click="removerDaLista(posto, index)">
                                <v-list-tile-avatar>
                                    <img v-if="posto.url_logo" :src="posto.url_logo" alt="logo posto" width="30">
                                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">{{ posto.nome_fantasia }}</v-list-tile-title>
                                    <v-list-tile-sub-title class="text-xs-center">{{ posto.cnpj }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="postosVinculados.length === 0">
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">Sem postos no momento</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-btn block color="primary" class="mt-4" @click="step=1">Confimar</v-btn>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step='4' class="pa-0">
                <v-layout row wrap justify-space-between class="pa-2">
                    <v-flex xs12>
                        <h3 class="text-xs-center">Insira as redes que você deseja vincular ao Cupom Apetrus</h3>
                        <v-tooltip bottom>
                          <v-btn slot="activator" class="mt-3" round small @click="inserirTodasRedes">Inserir todas</v-btn>
                          Inserir todas as redes
                        </v-tooltip>
                        <v-layout justify-center class="mt-3">
                          <v-flex xs8>
                            <v-text-field
                              v-model="filtroRede.nome__icontains"
                              label="Digite o nome do posto"
                              box
                              dense
                              prepend-inner-icon="search"
                            />
                          </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6>
                        <h4 class="text-xs-center">Lista de redes</h4>
                        <v-list style="border: 1px solid #BFBEBE; border-radius: 1em;  min-height: 30em; max-height: 30em; overflow:scroll; overflow-x:hidden;"  class="mr-1">
                            <v-list-tile v-for="(rede, index) in redesSemVinculo" :key="index" ripple @click="inserirRedeEmLista(rede, index)">
                                <v-list-tile-avatar>
                                    <img v-if="rede.url_logo" :src="rede.url_logo" alt="logo posto" width="30">
                                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">{{ rede.nome }}</v-list-tile-title>
                                    <v-list-tile-sub-title class="text-xs-center">{{ rede.matriz.cnpj }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="redesSemVinculo.length === 0">
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">Sem redes no momento</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs6>
                        <h4 class="text-xs-center">Redes vinculadas</h4>
                        <v-list style="border: 1px solid #BFBEBE; border-radius: 1em; min-height: 30em; max-height: 30em; overflow:scroll; overflow-x:hidden;" class="ml-1">
                            <v-list-tile v-for="(rede, index) in redesVinculadas" :key="index" ripple @click="removerRedeDaLista(rede, index)">
                                <v-list-tile-avatar>
                                    <img v-if="rede.url_logo" :src="rede.url_logo" alt="logo posto" width="30">
                                    <img v-else :src="require(`@/assets/logomarca.png`)" alt="logo posto" width="30">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">{{ rede.nome }}</v-list-tile-title>
                                    <v-list-tile-sub-title class="text-xs-center">{{ rede.matriz.cnpj }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="redesVinculadas.length === 0">
                                <v-list-tile-content>
                                    <v-list-tile-title class="text-xs-center">Sem redes no momento</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-btn block color="primary" class="mt-4" @click="step=1">Confimar</v-btn>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step='5' class="pa-0">
                <v-layout column v-if="codigoSelecionado" style="text-align: start;" class="subheading font-weight-regula">
                  <v-flex align-self-center>
                  <img v-if="codigoSelecionado.url_imagem_codigo" :src="codigoSelecionado.url_imagem_codigo" alt="Imagem do código" width="200">
                  <v-card v-else style="width: 200px; height: 200px; background-color: #DCDCDC;" class="elevation-0 mb-3">
                    <v-layout justify-center align-center fill-height>
                      <v-icon size="100">image</v-icon>
                    </v-layout>
                  </v-card>
                  </v-flex>
                  <span v-if="codigoSelecionado.link_site">Link para site: <a :href="codigoSelecionado.link_site" target="_blank" rel="noopener noreferrer">{{codigoSelecionado.link_site}}</a></span>
                  <span>Código do cupom: {{codigoSelecionado.codigo}}</span>
                  <span>{{new Date(`${codigoSelecionado.data_inicio}T00:00:00`) >= new Date()? 'Válido a partir de':'Ficou válido a partir de'}}: {{codigoSelecionado.data_inicio | formatDate('DD/MM/YYYY')}}</span>
                  <span v-if="codigoSelecionado.tem_data_fim">{{new Date(`${codigoSelecionado.data_fim}T00:00:00`) >= new Date()? 'Válido até':'Ficou válido até'}}: {{codigoSelecionado.data_fim | formatDate('DD/MM/YYYY')}}</span>
                  <span>Ganha: {{codigoSelecionado.desconto}}% de cashback</span>
                  <span>{{codigoSelecionado.combustivel ? `Viculado a ${codigoSelecionado.combustivel.nome}` : 'Vinculado a todos os combustíveis'}}</span>
                  <span v-if="codigoSelecionado.possui_valor_limite">Valor limite definido: R$ {{codigoSelecionado.valor_limite}}</span>
                  <span v-if="codigoSelecionado.possui_valor_limite">Restam: R$ {{(codigoSelecionado.valor_limite - codigoSelecionado.valor_usado).toFixed(2)}} a serem vendidos</span>
                  <span v-if="codigoSelecionado.qtd_codigos_limitado">Quantidade de códigos definida: {{codigoSelecionado.qtd_codigos}} códigos</span>
                  <span v-if="codigoSelecionado.qtd_codigos_limitado">Restam: {{codigoSelecionado.qtd_codigos - codigoSelecionado.qtd_codigos_usados}} códigos a serem vendidos</span>
                  <span v-if="codigoSelecionado.usos_limitados">Usuário pode usar: {{codigoSelecionado.qtd_usos_usuario}} {{codigoSelecionado.qtd_usos_usuario == 1? 'vez' : 'vezes'}}</span>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-dialog lazy persistent v-model="dialogBanner" width="500">
        <banner-codigo-promocional
          :codigo_promocional="codigoSelecionado"
          @close="dialogBanner = false"
          @success="carregarCodigos()"
        ></banner-codigo-promocional>
    </v-dialog>
    </v-card>
</template>
<script>
import { VMoney } from 'v-money'
const BannerCodigoPromocional = () =>
  import('../CarregarBannerCodigoPromocional')

export default {
  directives: { money: VMoney },
  components: { BannerCodigoPromocional },
  data () {
    let todayDate = new Date().toISOString().substr(0, 10)
    return {
      filtroPosto: {
        nome_fantasia__icontains: null,
        codigo_apetrus: null,
        vinculo_codigo__codigo_promocional: null
      },
      filtroRede: {
        nome__icontains: null,
        codigo_apetrus: null,
        vinculo_codigo__codigo_promocional: null
      },
      postosVinculados: [],
      postosSemVinculo: [],
      redesVinculadas: [],
      redesSemVinculo: [],
      menuDataInicial: false,
      codigoSelecionado: null,
      dialogBanner: false,
      step: 1,
      menuDataFinal: false,
      cadastrando: false,
      inserindoBanner: false,
      valid: false,
      consumo: [0, 200],
      codigos_promocionais: [],
      loadingCodigos: false,
      date_inicio: null,
      date_fim: null,
      today: Date.parse(todayDate),
      codigosPromocionais: [],
      precos: [],
      possuiLink: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      possui_limete_combustivel: false,
      possui_limete_por_cliente: false,
      codigo_model: {
        desconto: 0,
        codigo: null,
        possui_mensagem: false,
        mensagem_cupom: null,
        combustivel: null,
        data_inicio: null,
        tem_data_fim: false,
        data_fim: null,
        tipo_pagamento_limitado: false,
        qtd_codigos_limitado: false,
        usos_limitados: false,
        qtd_codigos: 500,
        qtd_usos_usuario: 1,
        qtd_litros: null,
        consumo_limitado: false,
        consumo_minimo: 0,
        consumo_maximo: 0,
        formas_pagamento: [],
        mostrar: true,
        possui_valor_limite: false,
        valor_limite: null,
        link_site: null,
        is_apetrus: true,
        rede: null,
        limite_por_cliente: null
      }
    }
  },
  methods: {
    carregarBanner (codigo) {
      this.codigoSelecionado = codigo
      this.dialogBanner = true
    },
    vicularPosto (codigo) {
      this.codigoSelecionado = codigo
      this.CarregarPosto()
      this.step = 3
    },
    vicularRede (codigo) {
      this.codigoSelecionado = codigo
      this.CarregarRedes()
      this.step = 4
    },
    visualizarDetalhes (codigo) {
      this.codigoSelecionado = codigo
      this.step = 5
    },
    carregarCodigos () {
      this.$store.dispatch('pegarCodigosPromocionais')
      .then(json => {
        this.codigosPromocionais = json
      }).catch(error => console.log(error))
    },
    cancelarCodigo (codigo) {
      this.$store
        .dispatch('cancelarCodigo', codigo.id)
        .then(() => {
          this.carregarCodigos()
        })
        .catch(() => {
          this.$emit(
            'error',
            'Não foi possível cancelar o código promocional, por favor, tente novamente mais tarde'
          )
        })
    },
    async CarregarPosto () {
      this.filtroPosto.codigo_apetrus = this.codigoSelecionado.id
      await this.$store.dispatch('pegarTodosPostos', this.filtroPosto).then(postos => {
        this.postosSemVinculo = postos.slice()
      })
      await this.$store.dispatch('pegarTodosPostos', {
        vinculo_codigo__codigo_promocional: this.codigoSelecionado.id
      }).then(postos => {
        this.postosVinculados = postos.slice()
      })
    },
    async CarregarRedes () {
      this.filtroRede.codigo_apetrus = this.codigoSelecionado.id
      await this.$store.dispatch('pegarTodasRedes', this.filtroRede).then(redes => {
        this.redesSemVinculo = redes.slice()
      })
      await this.$store.dispatch('pegarTodasRedes', {
        vinculo_codigo__codigo_promocional: this.codigoSelecionado.id
      }).then(redes => {
        this.redesVinculadas = redes.slice()
      })
    },
    inserirEmLista (posto, index) {
      this.$store.dispatch('vinculoCodigoPropocional', {
        cnpj: posto.cnpj,
        id_codigo: this.codigoSelecionado.id,
        method: 'POST'
      }).then(() => {
        this.postosVinculados.push(posto)
        this.postosSemVinculo.splice(index, 1)
      })
    },
    removerDaLista (posto, index) {
      this.$store.dispatch('vinculoCodigoPropocional', {
        cnpj: posto.cnpj,
        id_codigo: this.codigoSelecionado.id,
        method: 'DELETE'
      }).then(() => {
        this.postosSemVinculo.push(posto)
        this.postosVinculados.splice(index, 1)
      })
    },
    inserirTodosPosto () {
      this.postosSemVinculo.map((p, index) => this.inserirEmLista(p, index))
      this.postosSemVinculo = []
    },
    inserirRedeEmLista (rede, index) {
      this.$store.dispatch('vinculoCodigoPropocional', {
        id_rede: rede.id_rede,
        id_codigo: this.codigoSelecionado.id,
        method: 'POST'
      }).then(() => {
        this.redesVinculadas.push(rede)
        this.redesSemVinculo.splice(index, 1)
      })
    },
    removerRedeDaLista (rede, index) {
      this.$store.dispatch('vinculoCodigoPropocional', {
        id_rede: rede.id_rede,
        id_codigo: this.codigoSelecionado.id,
        method: 'DELETE'
      }).then(() => {
        this.redesSemVinculo.push(rede)
        this.redesVinculadas.splice(index, 1)
      })
    },
    inserirTodasRedes () {
      this.redesSemVinculo.map((r, index) => this.inserirRedeEmLista(r, index))
      this.redesSemVinculo = []
    },
    inserirCodigo () {
      if (this.codigo_model.valor_limite) {
        let valor = this.codigo_model.valor_limite.split(' ')[1].split(',')
        this.codigo_model.valor_limite = Number(`${valor[0].split('.').join('')}.${valor[1]}`)
        if (this.codigo_model.valor_limite <= 0) {
          return
        }
      }
      if (this.codigo_model.limite_por_cliente) {
        let valor = this.codigo_model.limite_por_cliente.split(' ')[1].split(',')
        this.codigo_model.limite_por_cliente = Number(`${valor[0].split('.').join('')}.${valor[1]}`)
        if (this.codigo_model.limite_por_cliente <= 0) {
          return
        }
      }
      this.$store
        .dispatch('inserirCodigoPromocional', {
          ...this.codigo_model,
          desconto: this.codigo_model.desconto
        })
        .then(() => {
          this.cadastrando = false
          this.loadData()
          this.carregarCodigos()
          this.$emit('notifications', 'Código cadastrado com sucesso')
          this.step = 1
        })
        .catch(() => {
          this.$emit(
            'error',
            'Não foi possível inserir o código promocional, por favor, verifique os dados e tente novamente.'
          )
        })
    },
    loadData () {
      this.codigo_model.consumo_minimo = this.consumo[0]
      this.codigo_model.consumo_maximo = this.consumo[1]
    },
    voltar () {
      this.codigo_model = {
        desconto: 0,
        ativo: true,
        codigo: null,
        possui_mensagem: false,
        mensagem_cupom: null,
        combustivel: null,
        data_inicio: null,
        tem_data_fim: false,
        data_fim: null,
        tipo_pagamento_limitado: false,
        qtd_codigos_limitado: false,
        usos_limitados: false,
        qtd_codigos: 500,
        qtd_usos_usuario: 1,
        qtd_litros: null,
        consumo_limitado: false,
        consumo_minimo: 0,
        consumo_maximo: 0,
        formas_pagamento: [],
        mostrar: true,
        possui_valor_limite: false,
        valor_limite: null,
        is_apetrus: true,
        limite_por_cliente: null
      }
      switch (this.step) {
        case 1:
          this.$emit('fechar')
          break
        case 2:
          this.step = 1
          break
        default:
          this.step = 1
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('carregarCombustiveis')
    this.carregarCodigos()
  },
  computed: {
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    loading () {
      return this.$store.getters.loading
    },
    valor_limite_teste () {
      if (this.codigo_model.valor_limite) {
        let valor = this.codigo_model.valor_limite.split(' ')[1].split(',')
        return Number(`${valor[0].split('.').join('')}.${valor[1]}`)
      }
      return 0
    },
    url_teste () {
      if (this.codigo_model.link_site && this.codigo_model.link_site.length > 7) {
        let valor = this.codigo_model.link_site.startsWith('https://') || this.codigo_model.link_site.startsWith('http://')
        return valor
      }
      return true
    },
    limite_por_cliente_teste () {
      if (this.codigo_model.limite_por_cliente) {
        let valor = this.codigo_model.limite_por_cliente.split(' ')[1].split(',')
        return Number(`${valor[0].split('.').join('')}.${valor[1]}`)
      }
      return 0
    }
  },
  watch: {
    'codigo_model.possui_mensagem' (val) {
      if (!val) {
        this.codigo_model.mensagem_cupom = null
      }
    },
    'codigo_model.possui_valor_limite' (val) {
      if (!val) {
        this.codigo_model.valor_limite = null
      }
    },
    'filtroPosto.nome_fantasia__icontains' (val) {
      this.CarregarPosto()
    },
    'filtroRede.nome__icontains' (val) {
      this.CarregarRedes()
    },
    possuiLink (val) {
      if (!val) {
        this.codigo_model.link_site = null
      }
    },
    possui_limete_combustivel (val) {
      this.codigo_model.combustivel = null
    },
    possui_limete_por_cliente () {
      this.codigo_model.limite_por_cliente = null
    },
    consumo (val) {
      this.codigo_model.consumo_minimo = val[0]
      this.codigo_model.consumo_maximo = val[1]
    },
    date_inicio (val) {
      this.menuDataInicial = false
      if (val) {
        this.codigo_model.data_inicio = val
          .split('-')
          .reverse()
          .join('/')
      } else {
        this.codigo_model.data_inicio = null
      }
    },
    date_fim (val) {
      this.menuDataFinal = false
      if (val) {
        this.codigo_model.data_fim = val
          .split('-')
          .reverse()
          .join('/')
      } else {
        this.codigo_model.data_fim = null
      }
    }
  }
}
</script>
